import React, { useEffect } from "react";
import PageHeading from "../../Components/PageHeading/PageHeading";
import HowItWorksDropdown from "./HowItWorksDropdown";
import two from '../../Assets/Images/Video-Poster/02.png'
import four from '../../Assets/Images/Video-Poster/04.png'


import './index.css'
import MetaData from "../../Components/MetaData/MetaData";

const HowItWorks = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [tabValue, setTabValue] = React.useState(0);
  const videoLinks = [
    "https://backend.whalesai.com/public/hiwvideos/businessplanai.mp4",    // BUSINESS PLAN AI (0)
    "https://backend.whalesai.com/public/hiwvideos/comicvideo.mp4",        // COMIC VIDEO AI (1)
    "https://backend.whalesai.com/public/hiwvideos/ConsultantAI.mp4",      // SOCIAL MEDIA CONSULTANT (2)
    "https://backend.whalesai.com/public/hiwvideos/factOfTheDayAI.mp4",      //FACT OF THE DAY AI (3)
    // "https://backend.whalesai.com/public/hiwvideos/developerai.mp4",         // DEVELOPER AI (3)
    "https://backend.whalesai.com/public/hiwvideos/ImageAI.mp4",           // IMAGE AI (4)
    "https://backend.whalesai.com/public/hiwvideos/MarketingPosterAI.mp4",   // PROMO CAMPAIGN AI (5)
    // "https://backend.whalesai.com/public/hiwvideos/newsvideo.mp4",         // NEWS VIDEO AI (5)
    "https://backend.whalesai.com/public/hiwvideos/PhotoPostAI.mp4",       // SOCIAL POST AI (6)
    "https://backend.whalesai.com/public/hiwvideos/PhotoPosterAI.mp4",     // POSTER AI (7)
    // "https://backend.whalesai.com/public/hiwvideos/PostAI.mp4",            // POST AI (8)
    "https://backend.whalesai.com/public/hiwvideos/ProductVideoAi.mp4",  // PRODUCT VIDEO AI (8)
    "https://backend.whalesai.com/public/hiwvideos/VideoAi.mp4",           //  VIDEO AI (9)
    "https://backend.whalesai.com/public/hiwvideos/TextAI.mp4",            // TEXT AI (10)
    // "https://backend.whalesai.com/public/hiwvideos/TextVideoAI.mp4",       // TEXT VIDEO AI (11)
    "https://backend.whalesai.com/public/hiwvideos/toystoriesai.mp4",       // TOY STORIES AI (12)
    "https://backend.whalesai.com/public/hiwvideos/voiceai.mp4",           // VOICE AI (13)
  ];

  const poster = [
    "/business-plan-ai.png",                                              // BUSINESS PLAN AI (0)
    "/comic-video-ai.png",                                                  // COMIC VIDEO AI (1)
    "https://backend.whalesai.com/public/hiwvideos/poster-consultantai.jpeg", // SOCIAL MEDIA CONSULTANT (2)
    "/fact-of-the-day.png",                                                     // FACT OF the day ai (3)
    // "/developer-ai.png",                                                  // DEVELOPER AI (3)
    "/image-ai.png",   // IMAGE AI (4)
    "/marketing-poster-ai.png",                                            // PROMO CAMPAIGN AI (5)
    // "https://backend.whalesai.com/public/hiwvideos/poster-newsvideoai.jpeg", // NEWS VIDEO AI (5)
    "/photo-post-ai.png",                                                 // SOCIAL POST AI (6)
    "/photo-poster-ai.png",                                                 // POSTER AI (7)
    // four,                                                                   // POST AI (8)
    "/product-video-ai.png",                                                // PRODUCT VIDEO AI (8)
    "/video-ai.png",                                                        // VIDEO AI (9)
    two,                                                                    // TEXT AI (10)
    // "/text-video-ai.png",                                                   // TEXT VIDEO AI (11)
    "/toy-stories-ai.png",                                                  // TOY STORIES AI (12)
    "/voice-ai.png",                                                        // VOICE AI (13)
  ];

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      <MetaData
        pageTitle={
          "Best Generative AI Tool for Beginners | Easy Generative AI"
        }
        pageDescription={
          "Find the best generative AI tools for beginners to create text, images, audio, and more. Enjoy user-friendly platforms designed for easy learning and creativity."
        }
        canonical="https://whalesai.com/how-it-works"
      ></MetaData>
      <PageHeading title={"HOW IT WORKS"} />
      <div className="container account-container pb-3">
        <HowItWorksDropdown tabValue={tabValue} handleChangeTab={handleChangeTab} />

        <div
          style={{ marginBlock: "20px" }}
          className="d-flex justify-content-center mx-auto video-container"
        >
          {/* "https://i.ibb.co/kqxs8Bw/companin.jpg" */}
          <video
            controls
            playsInline
            poster={poster[tabValue]}
            src={videoLinks[tabValue]}
            className="video-player"
            type="video/mp4"
          />
        </div>

      </div>
    </div>
  );
};

export default HowItWorks;
